import { render, staticRenderFns } from "./report-orders-table.vue?vue&type=template&id=3ca67a3e&scoped=true"
import script from "./report-orders-table.vue?vue&type=script&lang=js"
export * from "./report-orders-table.vue?vue&type=script&lang=js"
import style0 from "./report-orders-table.vue?vue&type=style&index=0&id=3ca67a3e&prod&lang=scss"
import style1 from "./report-orders-table.vue?vue&type=style&index=1&id=3ca67a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca67a3e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReportOrdersTableHeader: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-orders-table-header.vue').default,ReportOrdersTableRow: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-orders-table-row.vue').default,ReportPrintTitleReportName: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-print-title-report-name.vue').default,ReportOrderDetailsList: require('/home/runner/work/foaps-v2/foaps-v2/components/report/report-order-details-list.vue').default})
